module.exports = __webpack_public_path__ + "static/media/windows@2x.92d70d0d.png";